import * as React from 'react';
import classNames from 'classnames';
import Button from '../../../commonComponents/Button';
import { brightNavy, buttonBackgroundColorLight } from '../../cssConstants';

const SecondaryButton = ({ className, text, id, disabled, onClick, children, color, fontColor }: Props) => (
	<Button
		onClick={onClick}
		textColour={fontColor ?? brightNavy}
		backgroundColor={color ?? buttonBackgroundColorLight}
		className={classNames('formStyledButton', 'secondaryButton', className)}
		id={id}
		disabled={disabled}
	>
		<>
			{text}
			{children}
		</>
	</Button>
);

interface Props {
	text?: string;
	onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	id?: string;
	disabled?: boolean;
	className?: string;
	children?: string | JSX.Element;
	color?: string;
	fontColor?: string;
}

SecondaryButton.defaultProps = {
	text: null,
	id: 'secondaryButton',
	disabled: false,
	className: null,
	children: null,
	color: null,
	fontColor: null
};

export default SecondaryButton;
